/**
 * +14155550134 → (415) 555-0134.
 *
 * The API stores US mobiles in E.164. Anything that is not a US E.164 number
 * is returned as stored rather than guessed at.
 */
export const formatPhone = (phone?: string): string => {
  if (!phone) return '—';
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(phone);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
};
